// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bde7cb68","826":"87a79c08"}[chunkId] + ".chunk.js";
};